/*
 * Copyright (c) 2021 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import React from 'react'
import { Route, Switch, Redirect } from 'react-router'
import CreatePage from '../routes/create/CreatePage'
import ForgotPage from '../routes/forgot/ForgotPage'
import LoginPage from '../routes/landing/LoginPage'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import ChangePasswordPage from '../routes/changePassword/ChangePasswordPage'

const useCustomStyles = makeStyles(() => ({
  main: {
    flex: '1 0 auto',
  },
}))

/**
 * Content area.
 * @returns {Node} React node.
 */
function ContentArea() {
  const classes = useCustomStyles()

  //Instead of saving auth in state and having conditional routes, we protect an auth check via spring security
  // and then call that check for protected routes e.g. '/changepassword'
  return (
    <Box id='main-content-area' className={classes.main}>
      <Switch>
        <Route exact path='/' component={LoginPage} />
        <Route exact path='/create' component={CreatePage} />
        <Route exact path='/forgot' component={ForgotPage} />
        <Route exact path='/changepassword' component={ChangePasswordPage} />
        <Route path='/*'>
          <Redirect to='/' />
        </Route>
      </Switch>
    </Box>
  )
}

export default ContentArea
